<template>
  <div v-rect-loading="loading" class="third-integration-config-management">
    <div class="third-integration-config-header">
      <div class="header">
        <span class="third-integration-config-title">{{ $t(`${i18nPrefix}.title.thirdIntegrationConfigManagementTitle`) }}</span>
      </div>
    </div>
    <el-divider class="divider"></el-divider>
    <div class="settings-container ai-interview-config-container">
      <span class="title ai-interview-config-title">{{ $t(`${i18nPrefix}.label.aiInterviewConfigTitle`) }}</span>
      <div class="service-provider-select">
        <div class="label-container">
          <div class="label">{{ $t(`${i18nPrefix}.label.aiInterviewServiceProvider`) }}</div>
        </div>
        <el-select v-model="aiInterviewConfig.system_name" @change="handleSystemChange">
          <el-option
            v-for="(item, index) in AI_INTERVIEW_SERVICE_PROVIDER_LIST"
            :key="index"
            :label="$t(`${i18nPrefix}.SERVICE_PROVIDER.${item}`)"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div class="service-config-container">
        <WrappedForm
          ref="form"
          labelWidth="150px"
          :model="aiInterviewConfig.config"
          :formLines="formLines"
        >
        </WrappedForm>
      </div>
      <div class="callback-url">
        <div class="label-container">
          <div class="label">{{ $t(`${i18nPrefix}.label.aiInterviewCallbackUrl`) }}</div>
        </div>
        <el-input v-model="aiInterviewCallbackUrl" disabled></el-input>
      </div>
    </div>
    <div class="btn-group">
      <el-button class="save-btn" size="small" @click="handleClickSave">{{ $t('common.btn.save') }}</el-button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import WrappedForm from '@/components/formEditor/wrappedForm.vue'

const DUO_MIAN = 'DUO_MIAN'
const HRTPS = 'HRTPS'
const AI_INTERVIEW_SERVICE_PROVIDER_LIST = [DUO_MIAN, HRTPS]

export default {
  components: {
    WrappedForm
  },
  data () {
    return {
      AI_INTERVIEW_SERVICE_PROVIDER_LIST,
      i18nPrefix: 'admin.company.thirdIntegrationConfigManagement',
      loading: false,
      canEdit: false,
      aiInterviewConfig: {
        system_name: null,
        config: {}
      },
      originConfig: null
    }
  },
  computed: {
    formLines () {
      if (this.aiInterviewConfig.system_name === DUO_MIAN) {
        return {
          server_url: {
            disabled: !this.canEdit,
            label: this.$t(`${this.i18nPrefix}.label.serverUrl`),
            rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }]
          },
          app_key: {
            disabled: !this.canEdit,
            label: this.$t(`${this.i18nPrefix}.label.appKey`),
            rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }]
          },
          app_secret: {
            disabled: !this.canEdit,
            label: this.$t(`${this.i18nPrefix}.label.appSecret`),
            rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }]
          },
          salt: {
            disabled: !this.canEdit,
            label: this.$t(`${this.i18nPrefix}.label.appSalt`),
            rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }]
          },
          unique_code: {
            disabled: !this.canEdit,
            label: this.$t(`${this.i18nPrefix}.label.appUniqueCode`),
            rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }]
          }
        }
      } else if (this.aiInterviewConfig.system_name === HRTPS) {
        return {
          server_url: {
            disabled: !this.canEdit,
            label: this.$t(`${this.i18nPrefix}.label.serverUrl`),
            rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }]
          },
          app_id: {
            disabled: !this.canEdit,
            label: this.$t(`${this.i18nPrefix}.label.appId`),
            rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }]
          },
          code: {
            disabled: !this.canEdit,
            label: this.$t(`${this.i18nPrefix}.label.appCode`),
            rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }]
          },
          token: {
            disabled: !this.canEdit,
            label: this.$t(`${this.i18nPrefix}.label.appToken`),
            rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }]
          },
          msg_secret: {
            disabled: !this.canEdit,
            label: this.$t(`${this.i18nPrefix}.label.appMsgSecret`),
            rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }]
          }
        }
      } else {
        return {}
      }
    },
    aiInterviewCallbackUrl () {
      const domain = window.location.origin
      if (this.aiInterviewConfig.system_name === DUO_MIAN) {
        return `${domain}/v2/ai-interview/duomian-ai-report/`
      } else if (this.aiInterviewConfig.system_name === HRTPS) {
        return `${domain}/v2/ai-interview/hrtps-assessment-callback/`
      } else {
        return ''
      }
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    ...mapActions('interview', ['getCompanyAIInterviewConfig', 'createOrUpdateAIInterviewConfig']),
    initPage () {
      this.loadCompanyAIInterviewConfig()
    },
    async loadCompanyAIInterviewConfig () {
      this.loading = true
      try {
        const resp = await this.getCompanyAIInterviewConfig()
        if (resp) {
          this.canEdit = resp.can_edit
          this.aiInterviewConfig = resp
          this.originConfig = _.cloneDeep(resp)
        }
      } finally {
        this.loading = false
      }
    },
    handleResetConfig () {
      if (this.originConfig && this.originConfig.system_name === this.aiInterviewConfig.system_name) {
        this.aiInterviewConfig = _.cloneDeep(this.originConfig)
      } else {
        this.aiInterviewConfig.config = {}
      }
    },
    handleSystemChange () {
      this.handleResetConfig()
    },
    async handleClickSave () {
      const isValid = await this.$refs.form.submit()
      if (!isValid) {
        return
      }
      this.loading = true
      try {
        const params = {
          ...this.aiInterviewConfig
        }
        const resp = await this.createOrUpdateAIInterviewConfig(params)
        if (resp) {
          this.canEdit = resp.can_edit
          this.aiInterviewConfig = resp
          this.originConfig = _.cloneDeep(resp)
        }
        this.$message.success(this.$t('common.message.saveSuccess'))
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.third-integration-config-management {
  .third-integration-config-header {
    display: block;
    height: 32px;
    .header {
      display: inline-block;
      height: 32px;
      .third-integration-config-title {
        font-size: 20px;
        color: #303133;
        font-weight: 500;
        vertical-align: middle;
      }
    }
  }
  .divider {
    margin: 18px 0px 30px 0px;
  }

  .settings-container {
    > .title {
      display: block;
      font-size: 18px;
      margin-top: 24px;
      color: #303133;
      font-weight: 500;
    }
  }

  .ai-interview-config-container {
    .service-provider-select {
      width: 600px;
      margin: 24px auto;
      display: flex;
      align-items: center;
      .label-container {
        width: 150px;
        display: flex;
        justify-content: flex-end;
        padding-right: 24px;
        .label {
          font-size: 14px;
          color: #606266;
        }
      }
      .el-select {
        flex: 1;
      }
    }
    .service-config-container {
      width: 600px;
      margin: 0 auto;
    }
    .callback-url {
      width: 600px;
      margin: 24px auto;
      display: flex;
      align-items: center;
      .label-container {
        width: 150px;
        display: flex;
        justify-content: flex-end;
        padding-right: 24px;
        .label {
          font-size: 14px;
          color: #606266;
        }
      }
      .el-input {
        flex: 1;
      }
    }
  }

  .btn-group {
    margin-top: 66px;
    float: right;

    .save-btn {
      background: #0096CC;
      font-size: 16px;
      font-weight: 500;
      color: #FFFFFF;
      width: 88px;
      height: 40px;
    }
  }
}
</style>
